import { FieldType, FieldTypes } from "Store/FieldManagement/PropTypes";

export type ModuleId = string;

export interface SettingsModuleState {
    _isFetching: boolean,
    _forceFetch: boolean,
    ids: ModuleId[],
    entities: {},
    byEntityIdByModule: {}
}




export const getModuleFieldTypeLabelByFieldType = (type: FieldType) => {
    switch (type) {
        case FieldType.Text:
        case FieldType.Dropdown:
        case FieldType.HTML_Editor:
            return 'Tekstveld';
        case FieldType.Date:
            return 'Datum';
        case FieldType.Number:
            return 'Getal';
        case FieldType.Multi_Selector:
            return 'Labels/tags';
        case FieldType.Toggle:
            return 'Ja/Nee';
        case FieldType.Combination:
            return 'Combination Field';
        case FieldType.Predefined:
            return 'Predefined';
        case FieldType.Select:
        case FieldType.MultiSelect:
            return 'Select/Multiselect';
        default:
            return 'Unknown field type: ' + type;
    }
}

export const isFieldInModuleFieldType = (moduleFieldType: any, type: FieldTypes) => {
    let allowedTypes: any = [];
    switch (type) {
        case FieldType.Text:
        case FieldType.Dropdown:
        case FieldType.HTML_Editor:
            allowedTypes = [
                FieldType.Text,
                FieldType.Dropdown,
                FieldType.HTML_Editor,
                FieldType.Multi_Selector,
                FieldType.Combination,
                FieldType.Address
            ];
            break;
        case FieldType.Date:
            allowedTypes = [
                FieldType.Date
            ];
            break;
        case FieldType.Toggle:
            allowedTypes = [
                FieldType.Toggle
            ];
            break;
        case FieldType.Number:
            allowedTypes = [
                FieldType.Number
            ];
            break;
        case FieldType.Multi_Selector:
            allowedTypes = [
                FieldType.Multi_Selector
            ];
            break;
        case FieldType.Combination:
            allowedTypes = [
                FieldType.Combination
            ];
            break;
        case FieldType.Predefined:
            allowedTypes = [
                FieldType.Predefined
            ];
            break;
        default:
            return 'Unknown field type: ' + type;
    }

    return allowedTypes.includes(moduleFieldType); 
}